import { Link } from "@certn/cascadia-react";

interface ClickWrapCheckBoxLinkProps {
  title: string;
  url: string;
}

export function ClickwrapCheckBoxLink({
  title,
  url,
}: ClickWrapCheckBoxLinkProps) {
  return (
    <Link
      linkStyle="monochrome"
      textStyle="global/body-secondary"
      textColor="text-weak"
      href={url}
      testID="clickwrap-contract-link"
      target="_blank"
    >
      {title}
    </Link>
  );
}
